import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "categorii-panel" }
const _hoisted_2 = { class: "categorii-header" }
const _hoisted_3 = { class: "header-text" }
const _hoisted_4 = {
  key: 0,
  class: "panel-subtitle"
}
const _hoisted_5 = { class: "categorii-grid-container" }
const _hoisted_6 = { style: {"display":"flex","justify-content":"flex-end","gap":"8px","margin-top":"25px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxColumnChooser = _resolveComponent("DxColumnChooser")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxItemForm = _resolveComponent("DxItemForm")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxFormGrid = _resolveComponent("DxFormGrid")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("i", {
        class: "dx-icon dx-icon-tags",
        style: {"font-size":"18px","margin-right":"8px","opacity":"0.9"}
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "panel-title" }, "Categorii", -1)),
        (_ctx.ClasaNume)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.ClasaNume), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_DxDataGrid, {
        ref: "dataGridRef",
        "data-source": _ctx.dsCategorii,
        "key-expr": "ID",
        "remote-operations": true,
        onRowClick: _ctx.onRowClick,
        "focused-row-enabled": true,
        "focused-row-key": _ctx.focusedRowKey,
        onRowRemoving: _ctx.onRowRemoving,
        "show-row-lines": true,
        "hover-state-enabled": true,
        "show-borders": false,
        "show-column-lines": false,
        "row-alternation-enabled": false,
        height: "100%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DxStateStoring, {
            enabled: true,
            "storage-key": "grid-pro-categorii-state",
            type: "localStorage"
          }),
          _createVNode(_component_DxColumnChooser, { enabled: true }),
          _createVNode(_component_DxSearchPanel, {
            visible: true,
            placeholder: "Caută..."
          }),
          _createVNode(_component_DxSelection, { mode: "none" }),
          _createVNode(_component_DxFilterRow, { visible: true }),
          _createVNode(_component_DxPaging, {
            "page-size": 20,
            "page-index": 1
          }),
          _createVNode(_component_DxLoadPanel, {
            enabled: true,
            "indicator-src": 'reload6.gif'
          }),
          _createVNode(_component_DxSorting, { mode: "multiple" }),
          _createVNode(_component_DxToolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_DxItemForm, {
                name: "searchPanel",
                location: "before"
              }),
              _createVNode(_component_DxItem, { location: "after" }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxButton, {
                    icon: "add",
                    onClick: _ctx.onAddClick
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_DxItem, { location: "after" }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxButton, {
                    icon: "refresh",
                    onClick: _ctx.onRefreshClick
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_DxItemForm, {
                name: "columnChooserButton",
                location: "after"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxEditing, {
            allowUpdating: true,
            allowDeleting: true,
            mode: "popup"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxPopup, {
                closeOnOutsideClick: false,
                showCloseButton: false,
                width: 600,
                height: 580
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxToolbarItem, { template: _ctx.customTitleTemplate }, null, 8, ["template"]),
                  _createVNode(_component_DxToolbarItem, {
                    toolbar: "bottom",
                    widget: "dxButton",
                    location: "after",
                    options: _ctx.successButtonOptions
                  }, null, 8, ["options"]),
                  _createVNode(_component_DxToolbarItem, {
                    toolbar: "bottom",
                    widget: "dxButton",
                    location: "after",
                    options: _ctx.dangerButtonOptions
                  }, null, 8, ["options"])
                ]),
                _: 1
              }),
              _createVNode(_component_DxFormGrid, {
                "col-span": 1,
                "col-count": 1,
                "item-type": "group"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxItemForm, {
                    "data-field": "Nume",
                    "editor-options": { width: 560 }
                  }),
                  _createVNode(_component_DxItemForm, {
                    "col-span": 2,
                    "col-count": 2,
                    "item-type": "group"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxItemForm, { "data-field": "Cod" }),
                      _createVNode(_component_DxItemForm, {
                        "data-field": "JurnalCodInternId",
                        "editor-type": "dxSelectBox",
                        "editor-options": {
              dataSource: _ctx.dsCodIntern,
              valueExpr: 'ID',
              displayExpr: 'Cod',
              placeholder: 'Selectează',
            },
                        label: { text: 'Jurnal Cod Intern' }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxItemForm, {
                        "data-field": "ClasaId",
                        visible: false,
                        "editor-options": {
              dataSource: _ctx.dsClase,
              displayExpr: 'Id',
              valueExpr: 'ClasaID'
            }
                      }, null, 8, ["editor-options"]),
                      _createVNode(_component_DxItemForm, {
                        "data-field": "WwwID",
                        "editor-options": { showSpinButtons: true },
                        "editor-type": "dxNumberBox"
                      }),
                      _createVNode(_component_DxItemForm, {
                        "data-field": "WwwSyncedDate",
                        "editor-type": "dxDateBox",
                        "editor-options": { type: 'datetime', displayFormat: 'yyyy-MM-dd HH:mm' }
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxItemForm, {
                    "data-field": "CategorieContabilaDefaultId",
                    "editor-type": "dxSelectBox",
                    "editor-options": {
            dataSource: _ctx.dsCategoriiContabile,
            valueExpr: 'Id',
            displayExpr: 'Nume',
            placeholder: 'Selectează',
          },
                    label: { text: 'Categorie Contabilă' }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxItemForm, {
                    "col-span": 4,
                    "col-count": 4,
                    "item-type": "group"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxItemForm, {
                        "data-field": "Client",
                        "editor-type": "dxSwitch"
                      }),
                      _createVNode(_component_DxItemForm, {
                        "data-field": "Furnizor",
                        "editor-type": "dxSwitch"
                      }),
                      _createVNode(_component_DxItemForm, {
                        "data-field": "Editabil",
                        "editor-type": "dxSwitch"
                      }),
                      _createVNode(_component_DxItemForm, {
                        "data-field": "MateriePrima",
                        "editor-type": "dxSwitch"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxItemForm, {
                    "data-field": "Explicatie",
                    "editor-options": { width: 560, height: 100 }
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_DxColumn, { "data-field": "Cod" }),
          _createVNode(_component_DxColumn, { "data-field": "Nume" }),
          _createVNode(_component_DxColumn, {
            "data-field": "Client",
            "allow-search": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Furnizor",
            "allow-search": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Editabil",
            "allow-search": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "CategorieContabilaDefaultId",
            caption: "Categorie Contabilă",
            "allow-search": false,
            lookup: {
        dataSource: _ctx.dsCategoriiContabile,
        valueExpr: 'Id',
        displayExpr: 'Nume'
      }
          }, null, 8, ["lookup"]),
          _createVNode(_component_DxColumn, {
            "data-field": "MateriePrima",
            "allow-search": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "JurnalCodInternId",
            caption: "Jurnal Cod Intern",
            "allow-search": false,
            lookup: {
        dataSource: _ctx.dsCodIntern,
        valueExpr: 'ID',
        displayExpr: 'Cod'
      }
          }, null, 8, ["lookup"]),
          _createVNode(_component_DxColumn, {
            "data-field": "ClasaId",
            caption: "Clasa",
            "allow-search": false,
            lookup: {
        dataSource: _ctx.dsClase,
        valueExpr: 'ID',
        displayExpr: 'NumeArborescent'
      }
          }, null, 8, ["lookup"]),
          _createVNode(_component_DxColumn, {
            "data-field": "WwwID",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "WwwSyncedDate",
            visible: false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Explicatie",
            visible: false
          })
        ]),
        _: 1
      }, 8, ["data-source", "onRowClick", "focused-row-key", "onRowRemoving"])
    ]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isModalVisible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isModalVisible) = $event)),
      closeOnOutsideClick: false,
      showCloseButton: false,
      showTitle: true,
      width: 600,
      height: 580
    }, {
      title: _withCtx(() => [...(_cache[3] || (_cache[3] = [
        _createElementVNode("div", { style: {"background":"linear-gradient(90deg, #ff2c21, #ff6a4a)","font-size":"15px","color":"white","font-weight":"bold","padding":"12px 20px"} }, " Adăugare Categorie ", -1)
      ]))]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_DxForm, null, {
            default: _withCtx(() => [
              _createVNode(_component_DxItem, {
                "data-field": "Nume",
                "editor-options": {
            value: _ctx.formData.Nume,
            onValueChanged: e => _ctx.formData.Nume = e.value
          }
              }, null, 8, ["editor-options"]),
              _createVNode(_component_DxItem, {
                "col-span": 2,
                "col-count": 2,
                "item-type": "group"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxItem, {
                    "data-field": "Cod",
                    "editor-options": {
              value: _ctx.formData.Cod,
              onValueChanged: e => _ctx.formData.Cod = e.value
            }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxItem, {
                    "data-field": "JurnalCodInternId",
                    "editor-type": "dxSelectBox",
                    "editor-options": {
              value: _ctx.formData.JurnalCodInternId,
              onValueChanged: e => _ctx.formData.JurnalCodInternId = e.value,
              dataSource: _ctx.dsCodIntern,
              valueExpr: 'ID',
              displayExpr: 'Cod',
              showClearButton: true,
              placeholder: 'ex: Selectează'
            },
                    label: { text: 'Jurnal Cod Intern' }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxItem, {
                    "data-field": "ClasaId",
                    visible: false,
                    "editor-options": {
              dataSource: _ctx.dsClase,
              displayExpr: 'Id',
              valueExpr: 'ClasaID'
            }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxItem, {
                    "data-field": "WwwID",
                    "editor-options": {
              showSpinButtons: true, value: _ctx.formData.WwwID,
              onValueChanged: e => _ctx.formData.WwwID = e.value
            },
                    "editor-type": "dxNumberBox"
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxItem, {
                    "data-field": "WwwSyncedDate",
                    "editor-type": "dxDateBox",
                    "editor-options": {
              type: 'datetime', displayFormat: 'yyyy-MM-dd HH:mm', value: _ctx.formData.WwwSyncedDate,
              onValueChanged: e => _ctx.formData.WwwSyncedDate = e.value
            }
                  }, null, 8, ["editor-options"])
                ]),
                _: 1
              }),
              _createVNode(_component_DxItem, {
                "data-field": "CategorieContabilaDefaultId",
                "editor-type": "dxSelectBox",
                "editor-options": {
            dataSource: _ctx.dsCategoriiContabile,
            valueExpr: 'Id',
            displayExpr: 'Nume',
            showClearButton: true,
            width: 560,
            placeholder: 'ex: Selectează',
            value: _ctx.formData.CategorieContabilaDefaultId,
            onValueChanged: e => _ctx.formData.CategorieContabilaDefaultId = e.value
          },
                label: { text: 'Categorie Contabilă' }
              }, null, 8, ["editor-options"]),
              _createVNode(_component_DxItem, {
                "col-span": 4,
                "col-count": 4,
                "item-type": "group"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxItem, {
                    "data-field": "Client",
                    "editor-type": "dxSwitch",
                    "editor-options": {
              value: _ctx.formData.Client,
              onValueChanged: e => _ctx.formData.Client = e.value
            }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxItem, {
                    "data-field": "Furnizor",
                    "editor-type": "dxSwitch",
                    "editor-options": {
              value: _ctx.formData.Furnizor,
              onValueChanged: e => _ctx.formData.Furnizor = e.value
            }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxItem, {
                    "data-field": "Editabil",
                    "editor-type": "dxSwitch",
                    "editor-options": {
              value: _ctx.formData.Editabil,
              onValueChanged: e => _ctx.formData.Editabil = e.value
            }
                  }, null, 8, ["editor-options"]),
                  _createVNode(_component_DxItem, {
                    "data-field": "MateriePrima",
                    "editor-type": "dxSwitch",
                    "editor-options": {
              value: _ctx.formData.MateriePrima,
              onValueChanged: e => _ctx.formData.MateriePrima = e.value
            }
                  }, null, 8, ["editor-options"])
                ]),
                _: 1
              }),
              _createVNode(_component_DxItem, {
                "data-field": "Explicatie",
                "editor-options": {
            width: 560, height: 100, value: _ctx.formData.Explicatie,
            onValueChanged: e => _ctx.formData.Explicatie = e.value
          }
              }, null, 8, ["editor-options"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_DxButton, {
              text: "Salvează",
              type: "success",
              width: "100",
              onClick: _ctx.onSaveAdd
            }, null, 8, ["onClick"]),
            _createVNode(_component_DxButton, {
              text: "Închide",
              type: "danger",
              width: "100",
              onClick: _ctx.onCancel
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}